import React, { FC } from 'react'

import { isBefore, subDays } from 'date-fns'
import { styled } from '@creditas/stylitas'
import { Navigation } from '@creditas/icons'

import { clearCache } from 'facades/clearAssignmentCache'

import { Card } from './Card'
import { LeadInfo } from './LeadInfo'
import { LoanInfo } from './LoanInfo'

const Details = styled(Navigation.ArrowRight)`
  background: #fff;
  position: absolute;
  bottom: 16px;
  right: 16px;
  border: 1px solid #eee;
  border-radius: 50%;
  font-size: 48px;
  color: #778888;

  :hover {
    border-color: #4499ee;
    fill: #4499ee;
  }
`

const Assignment: FC<{ assignment: Workflow }> = ({ assignment }) => {
  const refreshInfo = () => {
    clearCache(assignment.id)
  }

  return (
    <Card
      key={assignment.id}
      data-testid="assignment-card"
      delayed={
        !assignment.scheduling ||
        isBefore(new Date(assignment.scheduling), subDays(new Date(), 1))
      }
      pendency={assignment.hasPendency}
      onClick={refreshInfo}
    >
      <LeadInfo
        name={assignment.fullName}
        cpf={assignment.cpf}
        applicationId={assignment.id}
      />
      <LoanInfo
        applicationId={assignment.id}
        pipelineStatus={assignment.pipelineStatus}
        nextContact={
          assignment.scheduling ? new Date(assignment.scheduling) : null
        }
        assignmentDate={assignment.assignmentDate}
        cpf={assignment.cpf}
      />
      <a href={`/auto-refi/${assignment.id}/linha-do-tempo`}>
        <Details />
      </a>
    </Card>
  )
}

export { Assignment }
